export const LANDING_HREF = 'https://streamiverse.io'
export const OBS_LEARN_MORE_HREF = 'https://obsproject.com/kb/stream-tutorial-2-alerts'
export const SUPPORT_EMAIL = 'support@streamiverse.io'
export const SUPPORT_HREF = `mailto:${SUPPORT_EMAIL}?subject=I%20have%20a%20question`
export const TERMS_OF_USE_HREF = 'https://streamiverse.io/terms-of-use'
export const PRIVACY_POLICY_HREF = 'https://streamiverse.io/privacy-policy'
